module.exports = __webpack_public_path__ + "static/media/agency.70e934df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/agency.jpg
// module id = 203
// module chunks = 0